import React, { useMemo } from "react";
import styles from "./select-products-modal.module.scss";
import { Field, Filter, SearchField, Autocomplete, Button } from "components/commons";
import locale from "localization";
import { Close } from "@material-ui/icons";

const SelectProductsFilter = ({
  filterState,
  modifyFilter,
  filterCount,
  applyFilter,
  applyClearFilter,
  searchKey,
  modifySearch,
  applySearch,
  applyClearSearch,
  resetFilter,
  countSelected = 0,
  actionText,
  actionProps,
  actionOnClick,
  uniqueProductTypes = [],
  placeholder = "",
  showFilter = true,
  disabled = { productType: false },
  allProducts = [],
  hiddenInputs = {
    productType: false,
  },
  categoriesOptions = [],
  initialFilterState,
}) => {
  const variantsOptions = useMemo(
    () =>
      [...new Set(allProducts?.map((p) => p.variant))]?.map((variant) => ({
        label: variant,
        value: variant,
      })),
    [allProducts]
  );
  return (
    <div className={styles?.container}>
      <div className={styles?.filter}>
        {showFilter && (
          <>
            <Filter
              close={resetFilter}
              clear={applyClearFilter}
              submit={() => {
                applyFilter();
              }}
              filterCount={filterCount}
            >
              {!hiddenInputs.productType && (
                <Field
                  label={locale.productType}
                  labelPosition={"left"}
                  className={styles.fieldSelect}
                  childrenClassName={styles.fieldContent}
                >
                  <Autocomplete
                    name={"productType"}
                    hasAll
                    multiple
                    {...filterState?.productType}
                    options={uniqueProductTypes}
                    onChange={(name, { value, isSelectedAll }) =>
                      modifyFilter({ [name]: { value, isSelectedAll } })
                    }
                    disabled={disabled.productType}
                  />
                </Field>
              )}
              <Field
                label={locale.productCategory}
                labelPosition={"left"}
                className={styles.fieldSelect}
                childrenClassName={styles.fieldContent}
              >
                <Autocomplete
                  name={"categoryIds"}
                  hasAll
                  multiple
                  {...filterState?.categoryIds}
                  options={categoriesOptions}
                  onChange={(name, { value, isSelectedAll }) =>
                    modifyFilter({ [name]: { value, isSelectedAll } })
                  }
                />
              </Field>
              <Field
                label={locale.variant}
                labelPosition={"left"}
                className={styles.fieldSelect}
                childrenClassName={styles.fieldContent}
              >
                <Autocomplete
                  name={"variants"}
                  hasAll
                  multiple
                  {...filterState?.variants}
                  options={variantsOptions}
                  onChange={(name, { value, isSelectedAll }) =>
                    modifyFilter({ [name]: { value, isSelectedAll } })
                  }
                />
              </Field>
            </Filter>
            <Field className={styles.search}>
              <SearchField
                restrict={false}
                searchWithSymbols
                placeholder={placeholder}
                value={searchKey}
                onChange={(_, { value }) => {
                  modifySearch(value);
                }}
                onEnter={applySearch}
                onClear={applyClearSearch}
              />
            </Field>
          </>
        )}
        {actionText && (
          <div className={styles.clearSelectedButton}>
            <Button onClick={actionOnClick} link {...(actionProps || {})}>
              {actionText}
              <Close fontSize="small" />
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default SelectProductsFilter;
